<template>
<div>
    <div v-if="loading">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Programm_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Programm_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Programm_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="!loading">
        <h3 v-if="trackId">2024 Track Sessions</h3>
        <!-- <h3 v-else>Program detail</h3> -->
        <div class="vue-program d-flex flex-wrap">
            <div class="col-12 p-0">
                <div class="session-item-filter">
                    <nav class="pl-0" role="navigation">
                        <h4 class="d-md-block d-none" v-if="typesFromQuery && typesFromQuery.length && typesFromQuery.length > 1">Filter By</h4>
                         <h4 class="d-md-none d-block" v-if="(typesFromQuery && typesFromQuery.length) || (tracksFromQuery && tracksFromQuery.length)">Filter By</h4>
                        <div>
                            <form id="filtering-form-vue" v-on:submit="getfilteredData" style="max-width: 530px;" class="d-flex flex-column flex-md-row">
                                <div v-if="tracksFromQuery && tracksFromQuery.length && tracksFromQuery.length > 1" class="filter-on-right-side-blocks d-md-none filter-on-right-side-second bootstrap-select mr-lg-3 mb-2">
                                    <!-- <label class="">TRACK</label> -->
                                    <select class="filterSelectVue program-filter-select" name="track" v-model="trackToFilter" @change="getUpdatedWeekDayAsGroup()">
                                        <option value="ALL" class="defaultFilterOption" selected="selected">TRACK</option>
                                        <option v-for="(aTrack, index) in tracksFromQuery" :value="aTrack._id" :key="index">{{aTrack.name}}</option>
                                    </select>
                                </div>
                                <div v-if="typesFromQuery && typesFromQuery.length && typesFromQuery.length > 1" class="filter-on-right-side-blocks filter-on-right-side-first mr-md-3">
                                    <div class="bootstrap-select-vue custom-select-vue">
                                        <!-- <label class="">SESSION-TYP</label> -->
                                        <select class="filterSelectVue program-filter-select" name="type" v-model="typeToFilter" @change="getUpdatedWeekDayAsGroup()">
                                            <option id="123" class="defaultFilterOption" selected="selected" value="ALL">SESSION-TYPE</option>
                                            <option v-for="(aType, index) in typesFromQuery" :value="aType._id" :key="index">{{aType.name}}</option>
                                        </select>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </nav>
                </div>
            </div>
            <!-- program display starts  -->
            <div class="col-12 col-lg-9 session-item-wrapper order-1 order-lg-0">
                <div class="">
                    <div id="timetable-overview-custom" class="gdlr-session-item gdlr-full-session-item gdlr-item" :class="['{{days}}' ? 'timetable-day-'+days : '']">
                        <div v-if="result && result.vueSessions && result.vueSessions.Sessions ">
                            <div v-for="(aDay, index) in programDisplay" :key="index" :id="'programJumpToDay'+index" class="mt-4">
                                <!-- program sticky header start -->
                                <div v-if="showTimeAndDate">
                                    <div class="gdlr-session-item-head gdlr-first onTop mb-4 pb-2" :class="{'thisisthefirstdivider d-flex d-md-block': index == 0,'onTop{{index}}' : true}">
                                        <a v-for="(aDayTime, aDayTimeIndex) in getAllSessionTimes()" :key="aDayTimeIndex" class="Test table-head-link sigle-day-active aDayLink" :class="{'sigle-day-not-active': index > 0 && index != aDayTimeIndex, [getaDayTimeIndex(aDayTimeIndex)] : true}" :href="'#programJumpToDay'+aDayTimeIndex">
                                            <div class="gdlr-session-item-head-info" :class="{'sands-active': index == aDayTimeIndex,'sands-not-active' : index != aDayTimeIndex}">
                                                <h4 class="gdlr-session-head-weekday">{{getDay(aDayTime)}}</h4>
                                                <div class="gdlr-session-head-date">{{aDayTime}}</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <!-- program sticky header ends -->
                                <div v-for="(session, sessionIndex) in aDay.sessions" :key="sessionIndex">
                                    <div v-if="session.type == 'Break'" class="gdlr-session-item-content-wrapper break-parent-container">
                                        <div class="session-break-content">
                                            <div class="session-break-info">
                                                <span v-if="showTimeAndDate && session.localizedStartDate">
                                                    {{getTime(session.localizedStartDate)}} - {{getTime(session.localizedEndDate)}}
                                                </span>
                                                <h3 class="gdlr-session-break-title">{{session.name}}</h3>
                                            </div>
                                        </div>
                                        <div class="clear"></div>
                                    </div>
                                    <div v-if="session.type != 'Break'" class="gdlr-session-item-content-wrapper">
                                        <div v-if="session.localizedStartDate" class="gdlr-session-item-content-info">
                                            <div class="col-xs-3 session-type-icons"></div>
                                            <div v-if="showTimeAndDate && session.localizedStartDate && session.localizedEndDate" class="col-xs-12 col-md-12 session-date_info">
                                                <div class="gdlr-session-info">
                                                    <div class="session-info session-time">
                                                        {{getTime(session.localizedStartDate)}} - {{getTime(session.localizedEndDate)}}
                                                    </div>
                                                </div>
                                                <span v-if="session.roomName">{{session.roomName}}</span>
                                            </div>
                                        </div>
                                        <div class="gdlr-session-item-content d-flex flex-wrap ">
                                            <div class="column d-none d-md-block speakers-image col-2">
                                                <div v-if="session && session.experts" class="column gdlr-session-thumbnail-wrapper">
                                                    <div v-for="(expert, index) in session.experts" :key="index" class="gdlr-speaker-thumbnail">
                                                        <div class="gdlr-speaker-thumbnail-inner resize">
                                                            <router-link v-if="expert && expert.slug" :to="`/speaker/${expert.slug}`">
                                                                <div v-if="expert.avatarSquareSmall && expert.avatarSquareSmall.xxx" class="sands-image-colored-overlay-hover">
                                                                    <img :src="expert.avatarSquareSmall.xxx" :alt="expert.surname" width="150" height="150">
                                                                </div>
                                                            </router-link>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="sessoin-speaker-title column col-12 col-md-10">
                                                <div class="session-type-icons">
                                                    <div class="cathead-img d-inline-block">
                                                        <div class="session-type-badge session-type-badge-styling cathead-img" :style="{'background-color':session.sessionType.colourHexCode}">
                                                            <p class="session-type-name session-type-name-color">{{session.sessionType.type}}</p>
                                                        </div>
                                                        <!-- take background color and image from redsys -->
                                                        <!-- <img width="97" height="23" v-if="session.sessionType && session.sessionType.image && session.sessionType.image.xx" :src="session.sessionType.image.xx"> -->
                                                    </div>
                                                </div>
                                                <h3 v-if="session.name" class="gdlr-session-item-title font-weight-bold text-break">
                                                    <router-link v-if="session.primaryTrack && session.primaryTrack.slug && session.slugNames && session.slugNames.length" :to="`/session/${session.slugNames[0]}`">{{session.name}}</router-link>
                                                    <span v-else>{{session.name}}</span>
                                                </h3>
                                                <div v-for="(expert, index) in session.experts" :key="index" class="twelve columns speakers-name-and-company">
                                                    <router-link v-if="expert && expert.surname && expert.forename && expert.slug" :to="`/speaker/${expert.slug}`">
                                                        {{expert.forename}} {{expert.surname}}<span v-if="expert && expert.company">, &nbsp;<em> {{expert.company}}</em></span>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                </div>
                            </div>
                        </div>
                        <div v-if="noSessionsForFilter" class="p-x-s rounded-s shadow-s text-center">
                            <h3>{{ $t('noSessionsAfterFilter') }}</h3>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <!-- program display Ends  -->
            <div class="col-12 col-lg-3">
                <div v-if="widgetHtml" class="filter-on-right-side-blocks filter-on-right-side-third mt-3 d-none d-lg-block">
                    <div class="addtional-after-filter-html">
                        <div class="vhtml" v-html="widgetHtml">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="stop-fixed-header">

    </div>
</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'
import moment from 'moment'

export default {
    name: 'programDisplay',
    props: {
        settingsPerm: Object,
        trackId: String
    },
    data() {
        return {
            result: false,
            days: null,
            noSessionsForFilter: false,
            showLanguageFlag: true,
            manipulateSessionTimeBy: false,
            seriesId: this.settingsPerm.seriesId,
            languageToDisplay:'de',
            tracksFromQuery: [],
            typesFromQuery: [],
            trackToFilter: 'ALL',
            typeToFilter: 'ALL',
            scrolled: false,
            stickyHeaderTop: false,
            loading: true,
            widgetHtml: false,
            showTimeAndDate:false,
            controllerweekDayGroup: false,
            programDisplay: false,
        };
    },
    watch: {
        trackId: function (newTrackIdForTrackDisplay, oldTrackIdForTrackDisply) { // watch it
            if (newTrackIdForTrackDisplay && newTrackIdForTrackDisplay != oldTrackIdForTrackDisply) {
                this.loading = true;
                this.tracksFromQuery = [];
                this.typesFromQuery = [];
                this.fetchProgramData();
            }
        }
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.appLanguage) {
            this.languageToDisplay = this.settingsPerm.appLanguage;
        }
        this.emitter.emit('tracksRelatedSessions', false);
        if (this.settingsPerm && this.settingsPerm.showTimeAndDates) {
            this.showTimeAndDate = this.settingsPerm.showTimeAndDates;
        }
        if (this.settingsPerm && this.settingsPerm.manipulateSessionTimeBy) {
            this.manipulateSessionTimeBy = this.settingsPerm.manipulateSessionTimeBy;
        }   
        if (this.settingsPerm && this.settingsPerm.callToAction) {
            this.widgetHtml = this.settingsPerm.callToAction;
        }
        if (!this.trackId) {
            this.fetchProgramData();
            this.emitter.emit('infoFromChild', {'isProgram':true});
        }
        if (this.trackId) {
            this.loading = true;
            this.tracksFromQuery = [];
            this.typesFromQuery = [];
            this.fetchProgramData();
        }
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    beforeMount() {
        setTimeout(() => {
            window.addEventListener('scroll', this.handleScroll);
        }, 3500);
    },
    methods: {
        getUpdatedWeekDayAsGroup() {
            this.programDisplay = this.getWeekDayAsGroup();
            this.getAllSessionTimes();
        },
        fetchProgramData() {
            this.result = false;
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: this.settingsPerm.concordBackendURL,
            })
            provideApolloClient(apolloClient)
            let variablesForQuery;
            if (this.trackId) {
                variablesForQuery = {
                    id: this.seriesId,
                    page: 1,
                    page_size: 300,
                    trackIn: this.trackId
                };
            } else {
                variablesForQuery = {
                    id: this.seriesId,
                    page: 1,
                    page_size: 300,
                    trackIn: ""
                };
            }

            const {
                result
            } = useQuery(CONCORD_QUERIES.SESSIONS_QUERY(variablesForQuery), variablesForQuery, {
                fetchPolicy: 'cache-first',
            });
            watch(result, value => {
                this.result = value;
                if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length) {
                    this.scrolled = false;
                    this.stickyHeaderTop = false;
                    let sessions = this.result.vueSessions.Sessions;
                    this.programDisplay = this.getWeekDayAsGroup();
                    sessions.forEach(aSession => {
                        if (aSession && aSession.sessionType && aSession.sessionType.type) {
                            let doWeFindAMatch = this.typesFromQuery.find(atyp => {
                                return atyp.uniqueId == aSession.sessionType.uniqueId
                            })
                            if (!doWeFindAMatch) {
                                this.typesFromQuery.push(aSession.sessionType);

                            }

                        }
                        if (aSession && aSession.tracks && aSession.tracks.length) {
                            aSession.tracks.forEach(aTrack => {
                                if (aTrack && aTrack.name && !this.tracksFromQuery.includes(aTrack)) {
                                    this.tracksFromQuery.push(aTrack);
                                }
                            });
                        }
                        this.loadingfilter = false;
                    });
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            })
        },
        getWeekDayAsGroup() {
            let weeKDaysAsDate = [];
            if (this.result && this.result.vueSessions && this.result.vueSessions.Sessions && this.result.vueSessions.Sessions.length) {
                if (this.typeToFilter || this.trackToFilter) {
                    let filteredSessions = [];
                    this.result.vueSessions.Sessions.forEach(aSession => {
                        let typeFilterMatches = true;
                        let trackFilterMatches = true;
                        if (this.typeToFilter && this.typeToFilter.length && this.typeToFilter != "ALL") {
                            typeFilterMatches = false;
                            if (aSession && aSession.sessionType && aSession.sessionType._id && aSession.sessionType._id === this.typeToFilter) {
                                typeFilterMatches = true;
                            }
                        }
                        if (this.trackToFilter && this.trackToFilter.length && this.trackToFilter != "ALL") {
                            trackFilterMatches = false;
                            if (aSession && aSession.trackIds && aSession.trackIds.length && aSession.trackIds.includes(this.trackToFilter)) {
                                trackFilterMatches = true;
                            }
                        }
                        if (typeFilterMatches && trackFilterMatches) {
                            filteredSessions.push(aSession);
                        }
                    });
                    if (filteredSessions && filteredSessions.length) {
                        filteredSessions.forEach(session => {
                            let startdate = moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                            weeKDaysAsDate.push({
                                startdate,
                                session
                            });
                        });

                    }
                } else {
                    this.result.vueSessions.Sessions.forEach(session => {
                        let startdate = moment(session.localizedStartDate, 'DD/MM/YYYY HH:mm:ss').format('DD-MM-YYYY');
                        weeKDaysAsDate.push({
                            startdate,
                            session
                        });
                    });
                }

            }
            const groupByTimes = (weeKDaysAsDate) => Object.values(weeKDaysAsDate.reduce((weeKDaysAsDate, {
                startdate,
                session
            }) => {

                if (weeKDaysAsDate[startdate]) {
                    weeKDaysAsDate[startdate].sessions.push(session);
                } else {
                    weeKDaysAsDate[startdate] = {
                        startdate,
                        sessions: [session]
                    };
                }
                return weeKDaysAsDate;
            }, {}));
            let weekDayGroup = groupByTimes(weeKDaysAsDate)
            if (weekDayGroup && weekDayGroup.length == 0) {
                this.noSessionsForFilter = true;
            } else {
                this.noSessionsForFilter = false;
            }
            this.loading = false;
            this.controllerweekDayGroup = weekDayGroup;
            return weekDayGroup;
        },
        getAllSessionTimes() {
            let weekDaysDate = [];
            if (this.controllerweekDayGroup && this.controllerweekDayGroup.length) {
                this.controllerweekDayGroup.forEach(aDayGroup => {
                    if (aDayGroup && aDayGroup.startdate) {
                        let startdate = moment(aDayGroup.startdate, 'DD-MM-YYYY').format('DD. MMM YYYY');
                        if (!weekDaysDate.includes(startdate)) {
                            weekDaysDate.push(startdate);
                        }
                    }
                });
            }
            this.days = weekDaysDate.length;
            return weekDaysDate;
        },
        getTime(localizedDate) {
            if (this.manipulateSessionTimeBy) {
                if (Math.sign(this.manipulateSessionTimeBy) === 1) {
                    return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').add(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
                } else if (Math.sign(this.manipulateSessionTimeBy) === -1) {
                    return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').subtract(Math.abs(this.manipulateSessionTimeBy), 'hours').format('HH:mm');
                }
            } else {
                return moment(localizedDate, 'DD/MM/YYYY HH:mm:ss').format('HH:mm');
            }

        },
        getDay(startDate) {
            moment.locale(this.languageToDisplay);
            return moment(startDate, 'DD. MMM YYYY').format('ddd');
        },

        getaDayTimeIndex(index) {
            return 'aSingleDayHeaderLink' + index;
        },
        handleScroll() {
            let $ = window.jQuery;
            if (!this.scrolled) {
                this.scrolled = true;
                this.calculateStickyHeaderTopWhenWeScroll();

            }
            var distanceTop = window.pageYOffset + 100;
            // get all dividers and check whats the current one
            var currentActiveDividerIdx = 0;
            var dividers = $(".gdlr-session-item-head:visible");
            $.each(dividers, function (dividerKey, aSingleDivider) {
                var elementsPosition = $(aSingleDivider).offset().top;
                // check if this is the active one
                if (distanceTop >= elementsPosition) {
                    currentActiveDividerIdx = dividerKey;
                }
            });
            // remove active class on all header links
            $('.aDayLink:visible').removeClass("activeDayLink");
            // add active to the current one only
            $('.aSingleDayHeaderLink' + currentActiveDividerIdx + ':visible').addClass("activeDayLink");

            //TODO: change the timetable header posiotion depend of the marketing banner
            var timetablePositionTop = "70px";
            var tmcb = $('.top-marketing-campaign-banner');
            // find the top banner class 
            if (tmcb.length && tmcb.html().length && tmcb.is(":visible")) {
                timetablePositionTop = "125px";
            }
            //Check when to make the timetable header sticky/fixed and when to make it static
            if ($(window).scrollTop() > this.stickyHeaderTop) {
                $('.thisisthefirstdivider').css({
                    'position': 'fixed',
                    'top': timetablePositionTop
                });
                var parentWidth = $('.gdlr-session-item-content-wrapper:visible').first().width();
                $('.thisisthefirstdivider').width(parentWidth);
                //get the first link wrapper to add margin
                if ($(window).scrollTop() > this.stickyHeaderTop) {
                    $('.gdlr-session-item-content-wrapper:visible').first().css({
                        'margin-top': '60px'
                    });
                }

            } else {
                $('.thisisthefirstdivider').css({
                    position: 'static',
                    top: '100px'
                });
                //get the first link wrapper to remove margin
                if (($(window).scrollTop() < this.stickyHeaderTop)) {
                    $('.gdlr-session-item-content-wrapper:visible').first().css({
                        'margin-top': '0px'
                    });
                }
            }

            var top_of_stop_element = '5000';
            var moving_heder_top = '500';
            if ($(".stop-fixed-header:visible").offset() && $(".thisisthefirstdivider").offset()) {
                top_of_stop_element = $(".stop-fixed-header:visible").offset().top - 100;
                moving_heder_top = $(".thisisthefirstdivider").offset().top;
            }
            var top_of_element = top_of_stop_element;
            var moving_header = moving_heder_top;
            if ((top_of_element <= moving_header)) {
                $('.thisisthefirstdivider').css({
                    'visibility': 'hidden'
                });
            } else if ((top_of_element > moving_header)) {
                $('.thisisthefirstdivider').css({
                    'visibility': 'visible'
                });
            }
        },

        calculateStickyHeaderTopWhenWeScroll() {
            let $ = window.jQuery;
            if ($('.gdlr-session-item-head') && $('.gdlr-session-item-head').length &&
                $('.gdlr-session-item-head').first() &&
                $('.gdlr-session-item-head').first().length &&
                $('.gdlr-session-item-head').first().offset() &&
                $('.gdlr-session-item-head:visible').first().offset() &&
                $('.gdlr-session-item-head:visible').first().offset().top !== 'undefined') {
                // this.stickyHeaderTop is first visible program header
                this.stickyHeaderTop = $('.gdlr-session-item-head:visible').first().offset().top;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.onTop {
    z-index: 9999;
    background-color: #fff;
}

.new-layout-container {
    padding: 25px 15px 15px 15px;
    height: 525px;
    border-radius: 15px;
}

.new-layout-container .speakers-image {
    padding: 0px;
}

.new-layout-container .row {
    margin: 0px !important;
}

.new-layout-container h3 {
    text-transform: none;
}

.eachSessionOfNewLayout {
    margin-bottom: 15px;
}

.gdlr-speaker-thumbnail-inner.resize {
    width: 70px
}

.gdlr-session-item .gdlr-speaker-thumbnail {
    max-width: 70px;
}

.eachSessionOfNewLayout .speakers-image {
    display: flex;
    justify-content: space-around;
}

.gdlr-session-item-title.m--t--0 {
    font-weight: 600;
}

.new-layout-container .gdlr-speaker-thumbnail {
    margin-bottom: 5px;
}

.gdlr-speaker-thumbnail-inner.resize img {
    height: 60px;
    object-fit: cover;
}

.new-layout-container a {
    color: #000;
}

.eachSessionOfNewLayout .session-type-name {
    margin: 0px;
    font-weight: 700;
}

.eachSessionOfNewLayout .speakers-name-and-company {
    font-size: 18px;
}

.new-layout-container .sands-image-colored-overlay-hover img {
    border-radius: 50%;
    height: 60px;
    width: 60px;
    object-fit: cover;
}

.session-display-small-new-layout {
    height: 490px;
    overflow-y: scroll;
    overflow-x: hidden;
    word-break: break-word;
}

.session-display-small-new-layout::-webkit-scrollbar {
    width: 12px;
}

.session-display-small-new-layout::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
}

.session-display-small-new-layout::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.filterSelectVue {
    width: 230px;
    font-size: 16px;
    border-radius: 10px;
}

.new-layout-session-type {
    padding: 7px 8px 5px 8px;
    background-color: #fff;
}

.new-layout-session-type h4 {
    margin: 0px;
    font-weight: 600;
}

.program-filter-select {
    padding: 5px;
}

.p--l--3 {
    padding-left: 12px;
}

.m--t--0 {
    margin-top: 0px;
}

.session-display-small-new-layout .session-type-icons {
    margin: 10px 0px 12px;
}

.session-type-badge-styling {
    padding: 0px 3px;
}

@media (min-width: 768px) {
    #timetable-overview-custom .sands-active {
        background-color: transparent !important;
    }
}

@media (max-width: 767px) {
    #timetable-overview-custom .sands-active {
        background-color: transparent !important;
    }

    .new-layout-container .sands-image-colored-overlay-hover img {
        height: 10vw;
        width: 10vw;
        border-radius: 50%;

    }

    .new-layout-container h3 {
        font-size: 20px;
        text-transform: none;
    }

    .eachSessionOfNewLayout .speakers-name-and-company {
        font-size: 16px;
    }
}

@media (max-width: 991px) {
    .eachSessionOfNewLayout .speakers-image {
        padding-left: 22px;
    }
}

.session-type-name-color {
    color: #fff;
    margin: 0;
    font-size: 19px;
    font-weight: 600;
}

select {
    background-color: #EBEBEB;
}

/* .filter-on-right-side-blocks {
    width: 100% !important;
} */

.sands-container .vueApp2 .session-item-filter .container-fluid {
    margin: 0px 30px;
}

.onTop .aDayLink .gdlr-session-item-head-info.sands-not-active,
.onTop .aDayLink .gdlr-session-item-head-info.sands-not-active,
.onTop .aDayLink .gdlr-session-item-head-info.sands-active {
    border-bottom: 12px solid #2D5A8D !important;
}

.onTop .activeDayLink.aDayLink .gdlr-session-item-head-info {
    border-bottom: 12px solid #0CBBEF !important;
}

@media only screen and (min-width:769px) {

    #timetable-overview-custom .gdlr-session-item-head.gdlr-first a.table-head-link {
        display: inline-block;

    }

    /* - timetable-day-2 - */
    .timetable-day-2 a.table-head-link:last-child .gdlr-session-item-head-info {
        /* border: 0px solid red !important;*/
    }

    #timetable-overview-custom.timetable-day-2 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 50%;
        max-width: 50%;
    }

    /* - timetable-day-3 - */
    .timetable-day-3 a.table-head-link:last-child .gdlr-session-item-head-info {
        /* border: 0px solid red !important;*/
    }

    #timetable-overview-custom.timetable-day-3 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 33.33%;
        max-width: 33.33%;
    }

    /* - timetable-day-4 - */
    .timetable-day-4 a.table-head-link:last-child .gdlr-session-item-head-info {
        /* border: 0px solid red !important;*/
    }

    #timetable-overview-custom.timetable-day-4 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 25%;
        max-width: 25%;

    }

    /* - timetable-day-5 - */
    .timetable-day-5 a.table-head-link:last-child .gdlr-session-item-head-info {
        /* border: 0px solid red !important;*/
    }

    #timetable-overview-custom.timetable-day-5 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 19.5%;
        max-width: 19.5%;
    }

    /* - timetable-day-6 - */
    .timetable-day-6 a.table-head-link:last-child .gdlr-session-item-head-info {
        /* border: 0px solid red !important;*/
    }

    #timetable-overview-custom.timetable-day-6 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 16.5%;
        max-width: 16.5%;
    }

    /* - timetable-day-7 - */
    .timetable-day-7 a.table-head-link:last-child .gdlr-session-item-head-info {
        /* border: 0px solid red !important;*/
    }

    #timetable-overview-custom.timetable-day-7 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 14%;
        max-width: 14%;
    }

    /* - timetable-day-8 - */
    .timetable-day-8 a.table-head-link:last-child .gdlr-session-item-head-info {
        border: 0px solid red !important;
    }

    #timetable-overview-custom.timetable-day-8 .gdlr-session-item-head.gdlr-first .table-head-link {
        min-width: 12%;
        max-width: 12%;
    }
}

#timetable-overview-custom .gdlr-session-item-head-info {
    max-width: 90% !important;
}

.gdlr-session-item-content-wrapper.break-parent-container {
    background-color: #F4F4F4 !important;
}

.gdlr-session-item-content-wrapper {
    background-color: #fff !important;
    border-bottom: 1px solid #707070;
    padding: 15px 0 15px 0;
}

.gdlr-session-item-content-wrapper {
    border-bottom: 1px solid #C3C3C3 !important;
}

.gdlr-session-item-content-wrapper .session-break-content {
    padding: 0px !important;
    margin-left: 15px !important;
}

.gdlr-session-item .session-break-info {
    color: #2c5a8c;
}

.session-break-content .gdlr-session-break-title {
    color: #3c3c3c;
    font-size: 15px;
    width: auto;
    display: inline;
    margin: 0 0 0 19px;
    letter-spacing: normal;
}

.gdlr-session-item .gdlr-session-item-head.gdlr-first {
    margin: 0 0 10px 0;
}

.gdlr-session-item .gdlr-session-item-content-info {
    width: 16%;
    float: left;
}

.sessoin-speaker-title h3.gdlr-session-item-title {
    margin: 3px 0;
}

.sessoin-speaker-title h3.gdlr-session-item-title {
    width: 95%;
}

.sessoin-speaker-title h3.gdlr-session-item-title {
    font-size: 20px;
    line-height: 20px;
}

.sessoin-speaker-title h3.gdlr-session-item-title {
    text-transform: none;
    color: #000 !important;

}

.sessoin-speaker-title h3 a {
    color: #000 !important;
}

.sessoin-speaker-title h3 a:focus,
.sessoin-speaker-title h3 a:hover {
    text-decoration: underline;
    color: #000 !important;
}

.d-flex.flex-wrap.gdlr-session-item-content {
    width: 83%;
}

.onTop .sigle-day-not-active {
    display: none !important;
}

.gdlr-session-item-head-info h4 {
    font-weight: 600;
    font-size: 23px;
    color: #000;
}
</style>
